// extracted by mini-css-extract-plugin
export default {"mainContainer":"PageNotFound_mainContainer__bU0yl","title":"PageNotFound_title__J2pY7","text":"PageNotFound_text__4vZF9"};